<template>
    <div class="card-content">
        <div class="row">
            <div class="col-6 sick">
                <div class="card content">
                    <div class="card-body text">
                        <p class="amount"><span class="amount-icon"><i class="fad fa-user-injured"></i></span>
                            {{ getSickCandidates }}
                        </p>
                        <p class="amount-text">ZIEK VANDAAG</p>
                    </div>
                </div>
            </div>
            <div class="col-6 vacancy">
                <div class="card content">
                    <div class="card-body text">
                        <p class="amount"><span class="amount-icon"><i class="fad fa-user-hard-hat"></i></span>
                            {{ getVacancies }}</p>
                        <p class="amount-text">VACATURES</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 placed">
                <div class="card content">
                    <div class="card-body text">
                        <p class="amount"><span class="amount-icon"><i class="fad fa-users"></i></span> {{
                            getActivePlacements }}
                        </p>
                        <p class="amount-text">KANDIDATEN AAN HET WERK</p>
                    </div>
                </div>
            </div>
            <div class="col-6 placings">
                <div class="card content">
                    <div class="card-body text">
                        <p class="amount"><span class="amount-icon"><i class="fad fa-calendar-alt"></i></span> {{
                            weekNumber }}</p>
                        <p class="amount-text">WEEK NUMMER</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'cards',
        props: ['dashboardData', 'weekNumber'],
        computed: {
            getSickCandidates() {
                return _.filter(this.dashboardData.candidates, {'sick': true}).length;
            },

            getActivePlacements() {
                let candidates = this.dashboardData.candidates;
                let placements = this.dashboardData.placements;

                candidates = candidates.map(candidate => {
                    let filteredPlacements = _.filter(placements, (placement) => {
                        // if(placement.endDate) {
                        //   console.log(moment(placement.endDate, 'YYYY-MM-DD').endOf('day').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY'),moment().isBefore(moment(placement.endDate, 'YYYY-MM-DD').endOf('day')) );
                        // }
                        if (placement.candidateId === candidate.id) {
                            return moment(placement.startDate, 'YYYY-MM-DD').isSameOrBefore(moment().startOf('day')) &&
                                (!placement.endDate || moment(placement.endDate, 'YYYY-MM-DD').isSameOrAfter(moment().startOf('day')));
                        }
                    });
                    candidate.activePlacement = !!filteredPlacements.length;
                    return candidate;
                });
                return _.filter(candidates, (candidate) => {
                    return candidate.activePlacement
                }).length;
            },

            getVacancies() {
                return this.dashboardData.vacancies.length;
            }
        }
    };
</script>

<style lang="scss">

    /* cards */
    .card-content {
        height: 900px;

    }

    .content {
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
        padding-top: 22px;
        padding-bottom: 22px;
        height: 470px;

    }

    .card-body {
        padding: 9.25rem;
    }

    .sick, .placed {
        padding-left: 0px;
        padding-right: 25px;
    }


    .vacancy, .placings {
        padding-right: 0px;
        padding-left: 7px;
    }

    .sick, .vacancy {
        padding-bottom: 25px;
    }

    .first-row, .second-row {
        padding: 0px 40px 30px 50px;
        margin-right: 0px !important;
        margin-left: -15px;
    }

    .text {
        text-align: center;
    }

    .amount {
        color: #25b7bc;

        font-size: 100px;
        font-weight: bolder;
        margin-bottom: 0px;

        .amount-icon {
            font-size: 80px;
            color: #505050;
        }
    }

    .amount-text {
        color: #505050;
        font-weight: bolder;
        font-size: 40px;

    }

</style>